export const environment = {
  production: true,
  rootUrl: 'https://sgms.kr',
};
